module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.newsArr), function(newsItem, index) {
    return (index < _vm.numberOfNewsToShow) ? _c('div', {
      staticClass: "d-flex mb-2 darker newsRowHolder"
    }, [_c('a', {
      staticClass: "colorInherit w-100 d-flex",
      attrs: {
        "href": newsItem.link,
        "target": "_blank"
      }
    }, [(newsItem.image) ? _c('div', {
      staticClass: "iamgeHolder",
      style: ('background-image: url(' + newsItem.image + ')')
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "textHolder px-2 d-flex flex-column justify-content-between",
      class: {
        'w-100': !newsItem.image
      }
    }, [_c('div', {
      staticClass: "font-weight-600 fs-large"
    }, [_vm._v(_vm._s(newsItem.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-small medium"
    }, [_vm._v(_vm._s(_vm.formatDate(newsItem.date) + ' ' + _vm.formatTime(newsItem.date)))])])])]) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 mb-2 font-weight-600"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v("News")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080f3ff2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardNews.vue
// module id = 2151
// module chunks = 0